/* sb-dc-viewfold.js — fold the "Install conditions" block away. 2026-09-04.

   The block does real work: the viewing distance sets the minimum text height,
   and that is what the proof checks against. Remove it and a 30ft-away banner
   gets judged by close-up rules, which means more "Needs fixing" on designs
   that are perfectly fine — the opposite of what we want.

   But almost nobody changes it, and as written it talks to a printer rather
   than to a customer: "the company standard 125 DPI", "practical floor 72
   DPI". So it collapses to one line that says what was chosen and what it
   means for the design:

       Medium (10-25ft) · smallest readable text 1.5"      [Change]

   Click Change and the original controls appear, untouched. The choice, the
   slider and the proof rules behave exactly as before; only the amount of
   screen it takes when nobody is using it has changed.

   The summary re-reads the live values, so it stays right when the distance
   changes or the product is swapped. If the panel is ever restructured and the
   heading stops matching, nothing folds and the customer sees the original
   block. Diagnostics: window.__dcViewFold.

   2026-09-12 — WORDING LIVES HERE, NOT IN sb-dc-plainwords.js.
   The plain-English pass briefly rewrote this row's "Viewing distance" and
   "min text" after the fact. That produced a visible flicker, and the cause is
   in this file: fold() runs every 400ms and rewrites the heading and the
   summary whenever they differ from what it expects, so the two scripts undid
   each other several times a second. The strings below are now the customer
   wording, and plainwords no longer touches this row. If this line ever needs
   rewording again, change it HERE.
*/
(function () {
  'use strict';

  var HEADING = /^install conditions$/i;
  var TITLE = 'How far away it will be seen';
  var MIN_LABEL = 'smallest readable text';
  var state = { folded: false, open: false, summary: '' };
  window.__dcViewFold = state;

  function css() {
    if (document.getElementById('sbdc-viewfold-css')) return;
    var st = document.createElement('style');
    st.id = 'sbdc-viewfold-css';
    st.textContent =
      '.sbdc-vf-row{display:flex;align-items:center;gap:8px;justify-content:space-between;' +
      'padding:9px 0;border-top:1px solid #e7ecef;border-bottom:1px solid #e7ecef;margin:6px 0 2px}' +
      '.sbdc-vf-txt{font:600 12.5px/1.4 inherit;color:#33404d}' +
      '.sbdc-vf-txt b{font-weight:700}' +
      '.sbdc-vf-btn{border:1px solid #cfd8de;background:#fff;border-radius:7px;padding:4px 10px;' +
      'font:600 12px/1 inherit;color:#00697f;cursor:pointer;white-space:nowrap}' +
      '.sbdc-vf-btn:hover{background:#e6f4f7}' +
      '[data-sbdc-vf="body"]{display:none !important}' +
      '[data-sbdc-vf="body"].is-open{display:revert !important}';
    document.head.appendChild(st);
  }

  function headingEl() {
    var hs = document.querySelectorAll('h1,h2,h3,h4');
    for (var i = 0; i < hs.length; i++) {
      if (HEADING.test((hs[i].textContent || '').trim())) return hs[i];
    }
    return document.querySelector('[data-sbdc-vf="head"]');
  }

  /* Everything between this heading and the next one is the block. */
  function bodyOf(h) {
    var out = [], n = h.nextElementSibling;
    while (n && !/^H[1-4]$/.test(n.tagName)) {
      if (!n.classList.contains('sbdc-vf-row')) out.push(n);
      n = n.nextElementSibling;
    }
    return out;
  }

  /* The chosen band and the minimum text height are rendered as their own
     small nodes; read them back rather than recompute anything. */
  function readValues(nodes) {
    var band = null, minText = null;
    for (var i = 0; i < nodes.length; i++) {
      var all = [nodes[i]].concat(Array.prototype.slice.call(nodes[i].querySelectorAll('*')));
      for (var j = 0; j < all.length; j++) {
        var el = all[j];
        if (el.children && el.children.length) continue;
        var t = (el.textContent || '').replace(/\s+/g, ' ').trim();
        if (!band && /\(\d+\s*[\u2013-]\s*\d+\s*ft\)/.test(t)) band = t;
        if (!minText && /^\d+(\.\d+)?(\u2033|")$/.test(t)) minText = t;
      }
    }
    return { band: band, minText: minText };
  }

  function fold() {
    var h = headingEl();
    if (!h) { state.folded = false; return; }
    h.dataset.sbdcVf = 'head';

    var body = bodyOf(h);
    if (!body.length) return;

    var row = h.parentNode.querySelector('.sbdc-vf-row');
    if (!row) {
      h.textContent = TITLE;
      body.forEach(function (n) { n.dataset.sbdcVf = 'body'; });

      row = document.createElement('div');
      row.className = 'sbdc-vf-row';
      var txt = document.createElement('span');
      txt.className = 'sbdc-vf-txt';
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'sbdc-vf-btn';
      btn.textContent = 'Change';
      btn.addEventListener('click', function () {
        state.open = !state.open;
        btn.textContent = state.open ? 'Done' : 'Change';
        var parts = h.parentNode.querySelectorAll('[data-sbdc-vf="body"]');
        for (var i = 0; i < parts.length; i++) parts[i].classList.toggle('is-open', state.open);
      });
      row.appendChild(txt);
      row.appendChild(btn);
      h.parentNode.insertBefore(row, h.nextSibling);
      state.folded = true;
    } else {
      /* React can rebuild the panel; re-mark anything new that appeared. */
      body.forEach(function (n) { if (!n.dataset.sbdcVf) {
        n.dataset.sbdcVf = 'body';
        n.classList.toggle('is-open', state.open);
      } });
      if ((h.textContent || '').trim() !== TITLE) h.textContent = TITLE;
    }

    var v = readValues(Array.prototype.slice.call(h.parentNode.querySelectorAll('[data-sbdc-vf="body"]')));
    var line = v.band || 'Medium';
    if (v.minText) line += ' \u00b7 ' + MIN_LABEL + ' <b>' + v.minText + '</b>';
    var txtEl = row.querySelector('.sbdc-vf-txt');
    if (txtEl.innerHTML !== line) txtEl.innerHTML = line;
    state.summary = txtEl.textContent;
  }

  function start() {
    css();
    var t = setInterval(function () { try { fold(); } catch (e) {} }, 400);
    window.addEventListener('pagehide', function () { clearInterval(t); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
